import { __assign, __awaiter, __generator } from "tslib";
import React, { createContext, useState, useCallback, } from 'react';
import hash from 'object-hash';
import { v4 as uuid } from 'uuid';
import GlobalAlerts from '../GlobalAlerts';
var ERROR_FRIENDLY_FALLBACK_MESSAGE = 'An error occurred. Try refreshing the page. If this keeps happening, please contact support.';
export var AlertContext = createContext({
    alerts: [],
    show: function () { return null; },
    dismiss: function () { },
    removeAlert: function () { },
    dismissAll: function () { },
});
/**
 * Attempts to render a user-friendly error message from an Error.
 * @param error
 */
var renderError = function (error) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        if (error.message) {
            return [2 /*return*/, error.message];
        }
        /* eslint-disable */
        console.error('Unknown error', error);
        return [2 /*return*/, ERROR_FRIENDLY_FALLBACK_MESSAGE];
    });
}); };
var hashAlert = function (contents, type, timeout, closeable) {
    var finalContents = typeof contents === 'string' ? contents : hash(contents);
    return hash("" + finalContents + type + timeout + closeable);
};
var AlertProvider = function (_a) {
    var children = _a.children, _b = _a.includeGlobalAlerts, includeGlobalAlerts = _b === void 0 ? true : _b;
    var _c = useState([]), alerts = _c[0], setAlerts = _c[1];
    var show = useCallback(function (type, contents, _a) {
        var _b = _a === void 0 ? {} : _a, id = _b.id, _c = _b.timeout, timeout = _c === void 0 ? 10000 : _c, onClose = _b.onClose, _d = _b.closeable, closeable = _d === void 0 ? true : _d, showConfetti = _b.showConfetti, animateIcon = _b.animateIcon;
        return __awaiter(void 0, void 0, void 0, function () {
            var renderedContents, _e, finalId;
            return __generator(this, function (_f) {
                switch (_f.label) {
                    case 0:
                        if (!(contents instanceof Error)) return [3 /*break*/, 2];
                        return [4 /*yield*/, renderError(contents)];
                    case 1:
                        _e = _f.sent();
                        return [3 /*break*/, 3];
                    case 2:
                        _e = contents;
                        _f.label = 3;
                    case 3:
                        renderedContents = _e;
                        finalId = id ||
                            (onClose
                                ? uuid()
                                : hashAlert(renderedContents, type, timeout, closeable));
                        setAlerts(function (currentAlerts) {
                            var existingAlert = currentAlerts.find(function (alert) { return alert.id === finalId; });
                            if (existingAlert) {
                                return currentAlerts
                                    .filter(function (alert) { return alert !== existingAlert; })
                                    .concat([
                                    __assign(__assign({}, existingAlert), { count: existingAlert.count + 1 }),
                                ]);
                            }
                            return currentAlerts.concat([
                                {
                                    id: finalId,
                                    count: 1,
                                    open: true,
                                    timeout: timeout,
                                    type: type,
                                    contents: renderedContents,
                                    showConfetti: showConfetti,
                                    animateIcon: animateIcon,
                                    onClose: onClose,
                                },
                            ]);
                        });
                        return [2 /*return*/, finalId];
                }
            });
        });
    }, []);
    var dismiss = useCallback(function (id) {
        setAlerts(function (currentAlerts) {
            var _a;
            var alert = currentAlerts.find(function (alert) { return alert.id === id; });
            (_a = alert === null || alert === void 0 ? void 0 : alert.onClose) === null || _a === void 0 ? void 0 : _a.call(alert);
            if (alert) {
                return currentAlerts
                    .filter(function (currentAlert) { return currentAlert !== alert; })
                    .concat([__assign(__assign({}, alert), { open: false })]);
            }
            return currentAlerts;
        });
    }, []);
    var dismissAll = useCallback(function () {
        setAlerts(function (currentAlerts) {
            currentAlerts.forEach(function (alert) {
                var _a;
                (_a = alert === null || alert === void 0 ? void 0 : alert.onClose) === null || _a === void 0 ? void 0 : _a.call(alert);
            });
            return currentAlerts.map(function (v) { return (__assign(__assign({}, v), { open: false })); });
        });
    }, []);
    var removeAlert = useCallback(function (id) {
        setAlerts(function (currentAlerts) {
            return currentAlerts.filter(function (currentAlert) { return currentAlert.id !== id; });
        });
    }, []);
    return (React.createElement(AlertContext.Provider, { value: {
            alerts: alerts,
            show: show,
            dismiss: dismiss,
            dismissAll: dismissAll,
            removeAlert: removeAlert,
        } },
        includeGlobalAlerts && React.createElement(GlobalAlerts, null),
        children));
};
export default AlertProvider;
//# sourceMappingURL=AlertProvider.js.map